import SFetch from '@app/utils/sfetch'
import { Meeting } from '@app/application/client_meetings/screens/past-meetings/utils/types'

export default {
  async getPastMeetings(): Promise<Meeting[] | void | null> {
    const url = window.Silverfin.Routes.client_meetings_completed_meetings_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )
    return await SFetch.jsonWithAlert<Meeting[]>(url)
  },
}
